<template>
	
	<div class="leftNav">
		
		
		<!-- <div  style="background: #000;padding:0 20px;">
		<img src="../assets/1651469562(1).png" alt="" class="logo">
	  </div> -->
		<el-menu :default-active="$route.path" class="el-menu-vertical-demo" :collapse="isCollapse">
		<div class="sysname">
			<img  :src="logo" style="width:20px;height: 20px;border-radius: 50%;margin-right: 4px;" />
			<span v-if="isCollapse==false" style="white-space: nowrap;">{{ $store.state.systemtitle }}</span>
			
		</div>
			<template  v-for="item in routeNav">
				<el-submenu :index="item.id+''" :key="item.id" v-if="!item.nonav&&!item.file_path" >
					<template slot="title">
						<!-- <i :class="item.icon" v-if="item.icon"></i> -->
						<el-image style="width: 18px; height: 18px;margin-right: 6px;" :src="item.ico"  v-if="item.ico"></el-image>
						<span>{{item.name}}</span>
					</template>
					<el-menu-item-group>
						<el-menu-item :index="ite.path" v-for="ite in item.children" v-if="!ite.nonav"
							@click="gopage(ite.path)">
							
							{{ite.name}}
						</el-menu-item>
				
					</el-menu-item-group>
				</el-submenu>
				<el-menu-item :index="item.path" v-if="!item.nonav&&item.file_path" 
					@click="gopage(item.path)">
					<el-image style="width: 18px; height: 18px;margin-right: 6px;" :src="item.ico"  v-if="item.ico"></el-image>
					<span>{{item.name}}</span>
					<!-- <div style="width: 90%;text-align: center;">{{item.name}}</div> -->
					<!-- <i :class="item.icon" v-if="item.icon"></i> -->
					
				</el-menu-item>
			</template>
			
			
		</el-menu>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				shop: {
					
				},
				logo:''
			}
		},
		computed: {
			isCollapse() {
				return this.$store.state.leftnav.isCollapse
			},
			routeNav() {
				return this.$store.state.routeNav
			},
		},
		created() {
			this.shop = JSON.parse(sessionStorage.getItem('shop'))
			
			this.logo = (sessionStorage.getItem('logo'))
		},
		methods: {
			gopage(path) {
				this.$router.push(path)
			}
		}
	}
</script>
<style>
	.sysname{width:100%;text-align: center;font-size: 17px;margin-bottom: 10px;color: #333;display: flex;align-items: center;font-weight: bold;justify-content: center;border-bottom: 1px solid #f0f0f0;height: 56px;border-right: 1px solid #f0f0f0;}
	.el-menu{background:#fff !important;border: none;}
	.el-submenu .el-menu-item{height: 44px;line-height: 44px;}
	.el-menu-item{font-size: 14px;color: #333;text-align: center;}
	.el-menu-item.is-active{background:#3A85FE ;color: white;font-size: 14px;}
	.el-menu-item, .el-submenu__title{height: 44px;line-height: 44px;display: flex;align-items: center;}
	.leftNav {
		height: calc(100vh);
		overflow-y: auto;
		background: #fff;
	}
</style>
<style scoped>
	
	
	.el-menu-vertical-demo:not(.el-menu--collapse) {
		width: 200px;
		height: calc(100vh - 60px);
		background: #F8F8F8;
	}

	

	.logo {
		width: 50px;
		height: 50px;
		text-align: center;

	}
	 
</style>
